(function() {
  "use strict";

  angular.module("PrintixAuth", [])

    .constant("PrintixAuthConstants", {
      AUTH_REQUEST_API_TOKENS_DONE: "auth_request_api_tokens_done",
      AUTH_REFRESH_ACCESS_TOKEN_DONE: "auth_refresh_access_token_done",
      AUTH_TOKEN_TIMEOUT: "AuthTokenTimeout",
      EXPIRES_IN: "expires_in",
      ACCESS_TOKEN: "access_token",
      REFRESH_TOKEN: "refresh_token",
      TOKEN_TIME_STAMP: "TokenTimeStamp",
      AUTH_ACCESS_TOKEN: "AuthAccessToken",
      AUTH_REFRESH_TOKEN: "AuthRefreshToken",
      // URL_LOGIN_SUFFIX: "?response_type=code&client_id=web_app&client_secret=thehouseisonfire&redirect_uri=",
      URL_LOGIN_SUFFIX: "?response_type=code&client_id=admin&client_secret=thehouseisonfire&redirect_uri=",
      URL_PARAMETER_REFRESH_TOKEN: "refreshToken",
      URL_PARAMETER_CODE: "code",
      URL_PARAMETER_CODE_INVITE: "inviteCode",
      URL_PARAMETER_TEMP_ACCESS_RESOURCE_URI: "temp_access_resource_uri"
    })

    .service("Auth", ["$rootScope", "EnvironmentService", "localStorageService", "$location", "$window", "Utils", "PrintixErrorConstants",
      "PrintixAuthConstants", "$cookies", "$filter", "URLS", "CURRENT_APP_PERMISSION", "$http", "$q",
      function($rootScope, EnvironmentService, localStorageService, $location, $window, Utils, PrintixErrorConstants,
        PrintixAuthConstants, $cookies, $filter, URLS, CURRENT_APP_PERMISSION, $http, $q) {


        //START VARIABLES**************************************************************************************/
        var AuthPrivate = {},
          storageObject = null;
        AuthPrivate.isRefreshAccessTokenRunning = false;
        AuthPrivate.isGetAPITokensRunning = false;
        AuthPrivate.isCheckCredentialsRunning = false;
        AuthPrivate.isSignOutRunning = false;
        AuthPrivate.URL_GetAccessToken = EnvironmentService.authBaseUrl + "/oauth/token";
        AuthPrivate.URL_SignOut = EnvironmentService.authBaseUrl + "/oauth/revoke?token=";
        AuthPrivate.URL_SignIn = EnvironmentService.authBaseUrl + "/oauth/authorize/tenant/" + $location.host() + PrintixAuthConstants.URL_LOGIN_SUFFIX;
        //START VARIABLES**************************************************************************************/


        //SET storage object which will be used to persist data on the client browser**************************/
        if (localStorageService.isSupported) {
          storageObject = localStorageService;
        } else {
          storageObject = $cookies;
          storageObject.set = function(key, value) {
            return storageObject.put(key, value);
          };
        }
        //SET storage object which will be used to persist data on the client browser**************************/


        //START AUTH INFORMATION GETTERS AND SETTERS***********************************************************/
        AuthPrivate.getAccessToken = function() {
          return storageObject.get(PrintixAuthConstants.AUTH_ACCESS_TOKEN);
        };

        AuthPrivate.checkIfRefreshTokenIsSet = function() {
          return (storageObject.get(PrintixAuthConstants.AUTH_REFRESH_TOKEN) && !angular.isString($location.search()[PrintixAuthConstants.URL_PARAMETER_CODE_INVITE])) ? true : false;
        };

        AuthPrivate.checkIfTokensAreSet = function(ignoreAccessTokenCheck) {
          if ((AuthPrivate.getAccessToken() || ignoreAccessTokenCheck) && storageObject.get(PrintixAuthConstants.AUTH_REFRESH_TOKEN)) {
            return true;
          } else {
            return false;
          }
        };
        //END GETTERS AND SETTERS******************************************************************************/


        //START AuthPrivate************************************************************************************/
        AuthPrivate.sanitizeUrl = function() {
          setIdpLoginToken();
          
          $location.search(PrintixAuthConstants.URL_PARAMETER_REFRESH_TOKEN, null);
          $location.search(PrintixAuthConstants.URL_PARAMETER_CODE, null);
          $location.search(PrintixAuthConstants.URL_PARAMETER_CODE_INVITE, null);
          $location.search(PrintixAuthConstants.URL_PARAMETER_TEMP_ACCESS_RESOURCE_URI, null);

          $location.search('idpLoginToken', null);
        };

        function setIdpLoginToken() {
          var idpLoginToken = angular.copy($location.search()['idpLoginToken']);
          
          if (idpLoginToken) {
            storageObject.set('idpLoginToken', idpLoginToken)
            var token = angular.copy(storageObject.get('idpLoginToken'))
            var decodedToken =  JSON.parse(atob(token.split('.')[1]))
            storageObject.set('idpLoginTokenExpireTime', decodedToken.exp)
          }

        }

        AuthPrivate.setAuthData = function(data) {
          if (data && data[PrintixAuthConstants.ACCESS_TOKEN] &&
            data[PrintixAuthConstants.REFRESH_TOKEN] &&
            data[PrintixAuthConstants.EXPIRES_IN]) {
            storageObject.set(PrintixAuthConstants.AUTH_REFRESH_TOKEN, data[PrintixAuthConstants.REFRESH_TOKEN]);
            storageObject.set(PrintixAuthConstants.AUTH_ACCESS_TOKEN, data[PrintixAuthConstants.ACCESS_TOKEN]);
            storageObject.set(PrintixAuthConstants.AUTH_TOKEN_TIMEOUT, data[PrintixAuthConstants.EXPIRES_IN]);
            storageObject.set(PrintixAuthConstants.TOKEN_TIME_STAMP, new Date().getTime());
            
          } else {
            throw "AuthPrivate.setAuthData: data or data[PrintixAuthConstants.ACCESS_TOKEN] or data[PrintixAuthConstants.REFRESH_TOKEN] or data[PrintixAuthConstants.AUTH_TOKEN_TIMEOUT] are missing";
          }
        };

        AuthPrivate.removeAuthData = function() {
          storageObject.remove(PrintixAuthConstants.AUTH_ACCESS_TOKEN);
          storageObject.remove(PrintixAuthConstants.AUTH_TOKEN_TIMEOUT);
          storageObject.remove(PrintixAuthConstants.TOKEN_TIME_STAMP);
          storageObject.remove(PrintixAuthConstants.AUTH_REFRESH_TOKEN);
        };

        AuthPrivate.signOut = function(callback, url, errorMessage) {
          if (!AuthPrivate.isSignOutRunning) {
            AuthPrivate.isSignOutRunning = true;
            $http.get(AuthPrivate.URL_SignOut + storageObject.get(PrintixAuthConstants.AUTH_REFRESH_TOKEN), {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded"
              }
            }).then(function() {
              AuthPrivate.removeAuthData();
              if (url) {
                $window.location.href = url;
              } else {
                if (callback) {
                  callback();
                }
                AuthPrivate.sanitizeUrl();
                var url = AuthPrivate.URL_SignIn + encodeURIComponent($location.absUrl());
                if (errorMessage) {
                  url += "&propagate_error=" + errorMessage;
                }
                console.warn(url)
                $window.location.href = url;
              }
            }).catch(function(error){});;
          }
        };

        /*AuthPrivate.setRedirectUrl = function () {
          var url = $location.absUrl();
          if (url.indexOf('.devenv.printix.net') !== -1) {
            return 'http://sign-in.devenv.printix.net/tenanthub';
          } else if (url.indexOf('.testenv.printix.net') !== -1) {
            return 'https://sign-in.testenv.printix.net/tenanthub';
          } else {
            return 'https://sign-in.printix.net/tenanthub';
          }
        }*/

        AuthPrivate.checkIfCurrentUserHasAccessToTheCurrentApp = function() {
          if ($rootScope.currentUser && !$filter("contains")($rootScope.currentUser.info._embedded.permissions.permissions, CURRENT_APP_PERMISSION)) {
            AuthPrivate.signOut(null, null, "ACCESS_DENIED");
          }
        };

        AuthPrivate.startRequestAPITokens = function(promise) {
          if (promise) {
            AuthPrivate.requestAPITokens().then(function() {
              AuthPrivate.isCheckCredentialsRunning = false;
              promise.resolve();
            }).catch(function(error){
              AuthPrivate.isCheckCredentialsRunning = false;
              promise.reject();
            });
          } else {
            throw "AuthPrivate.startRequestAPITokens: promise is missing";
          }
        };

        AuthPrivate.startRefreshAccessToken = function(promise) {
          if (promise) {
            AuthPrivate.refreshAccessToken().then(function() {
              AuthPrivate.isCheckCredentialsRunning = false;
              promise.resolve();
            }).catch(function(error){
              AuthPrivate.isCheckCredentialsRunning = false;
              promise.reject();
            });
          } else {
            throw "AuthPrivate.startRefreshAccessToken: promise is missing";
          }
        };

        AuthPrivate.checkCredentials = function() {
          var deferred = $q.defer();
          if (!AuthPrivate.isCheckCredentialsRunning && !AuthPrivate.isSignOutRunning) {
            AuthPrivate.isCheckCredentialsRunning = true;
            if (angular.isString($location.search()[PrintixAuthConstants.URL_PARAMETER_REFRESH_TOKEN])) {
              storageObject.set(PrintixAuthConstants.AUTH_REFRESH_TOKEN, $location.search()[PrintixAuthConstants.URL_PARAMETER_REFRESH_TOKEN]);
              AuthPrivate.startRefreshAccessToken(deferred);
            } else if (angular.isString($location.search()[PrintixAuthConstants.URL_PARAMETER_CODE]) ||
              angular.isString($location.search()[PrintixAuthConstants.URL_PARAMETER_CODE_INVITE])) {
              AuthPrivate.startRequestAPITokens(deferred);
            } else {
              if (!storageObject.get(PrintixAuthConstants.AUTH_REFRESH_TOKEN) && !AuthPrivate.isGetAPITokensRunning &&
                !AuthPrivate.isRefreshAccessTokenRunning) {
                AuthPrivate.signOut();
              } else {
                if (AuthPrivate.checkIfAccessTokenIsValid()) {
                  AuthPrivate.isCheckCredentialsRunning = false;
                  deferred.resolve();
                } else {
                  AuthPrivate.startRefreshAccessToken(deferred);
                }
              }
            }
          } else {
            if (!AuthPrivate.isSignOutRunning) {
              var watch = $rootScope.$watch(function() {
                return AuthPrivate.isCheckCredentialsRunning;
              }, function(newValue, oldValue) {
                if (newValue === false && oldValue === true) {
                  watch();
                  deferred.resolve();
                }
              });
            }
          }
          return deferred.promise;
        };

        AuthPrivate.requestAPITokens = function() {
          var deferred = $q.defer();
          if (!AuthPrivate.isGetAPITokensRunning) {
            AuthPrivate.isGetAPITokensRunning = true;
            var code = angular.copy($location.search()[PrintixAuthConstants.URL_PARAMETER_CODE]);
            

            var codeInvite = angular.copy($location.search()[PrintixAuthConstants.URL_PARAMETER_CODE_INVITE]);
            if (angular.isString(code) || angular.isString(codeInvite)) {
              var dataToSend = null;
              var url = null;
              AuthPrivate.sanitizeUrl();
              if (code) {
                url = AuthPrivate.URL_GetAccessToken;
                dataToSend = "grant_type=authorization_code&code=" + code + "&redirect_uri=" +
                  encodeURIComponent($location.absUrl()) + "&client_id=admin&client_secret=thehouseisonfire";
              }
              if (codeInvite) {
                url = EnvironmentService.authBaseUrl + "/oauth/tempUser";
                dataToSend = PrintixAuthConstants.URL_PARAMETER_TEMP_ACCESS_RESOURCE_URI + "=" + codeInvite;
              }
              if (url && dataToSend) {
                $http.post(url, dataToSend, {
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                  }
                }).then(function(response) {
                  if (response && response.data) {
                    if (angular.isString($location.search()[PrintixAuthConstants.URL_PARAMETER_CODE])) {
                      $location.search(PrintixAuthConstants.URL_PARAMETER_CODE, null);
                    }
                    if (angular.isString($location.search()[PrintixAuthConstants.URL_PARAMETER_CODE_INVITE])) {
                      $location.search(PrintixAuthConstants.URL_PARAMETER_CODE_INVITE, null);
                    }
                    AuthPrivate.setAuthData(response.data);
                    AuthPrivate.isGetAPITokensRunning = false;
                    deferred.resolve(response);
                  } else {
                    throw "AuthPrivate.requestAPITokens: response or response.data are missing";
                  }
                }).catch(function(error){
                  AuthPrivate.isGetAPITokensRunning = false;
                  if (error.status === 401) {
                    AuthPrivate.signOut();
                  }
                  deferred.reject(error);
                });
              } else {
                throw "AuthPrivate.requestAPITokens: url or dataToSend are missing";
              }
            } else {
              throw "AuthPrivate.requestAPITokens: code or codeInvite are missing";
            }
          } else {
            deferred.reject("AuthPrivate.requestAPITokens: AuthPrivate.isGetAPITokensRunning is true");
          }
          return deferred.promise;
        };

        AuthPrivate.refreshAccessToken = function() {
          var deferred = $q.defer();
          if (AuthPrivate.checkIfTokensAreSet(true)) {
            if (!AuthPrivate.isRefreshAccessTokenRunning) {
              AuthPrivate.isRefreshAccessTokenRunning = true;
              var data = "grant_type=refresh_token&refresh_token=" + storageObject.get(PrintixAuthConstants.AUTH_REFRESH_TOKEN) + "&client_id=admin&client_secret=thehouseisonfire";
              // var data = "grant_type=refresh_token&refresh_token=" + storageObject.get(PrintixAuthConstants.AUTH_REFRESH_TOKEN) + "&client_id=web_app&client_secret=thehouseisonfire";
              AuthPrivate.sanitizeUrl();
              $http.post(AuthPrivate.URL_GetAccessToken, data, {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded"
                }
              }).then(function(response) {
                  AuthPrivate.setAuthData(response.data);
                  AuthPrivate.isRefreshAccessTokenRunning = false;
                  deferred.resolve(response);
                }).catch(function(error) {
                  AuthPrivate.isRefreshAccessTokenRunning = false;
                  if (error.status === 401) {
                    AuthPrivate.signOut();
                  }
                  deferred.reject(error);
                });
            } else {
              var watch = $rootScope.$watch(function functionName() {
                return AuthPrivate.isRefreshAccessTokenRunning;
              }, function(newValue, oldValue) {
                if (newValue === false && oldValue === true) {
                  watch();
                  deferred.resolve();
                }
              });
            }
          } else {
            deferred.reject("AuthPrivate.refreshAccessToken: tokens are not set");
          }
          return deferred.promise;
        };

        AuthPrivate.checkIfAccessTokenIsValid = function() {
          var date = new Date();
          var tokenTimeStamp = storageObject.get(PrintixAuthConstants.TOKEN_TIME_STAMP);
          var tokenTimeOut = storageObject.get(PrintixAuthConstants.AUTH_TOKEN_TIMEOUT);
          if (tokenTimeStamp && tokenTimeOut) {
            var tokenTimeOutFixed = tokenTimeOut - 20;
            if ((tokenTimeStamp + (tokenTimeOutFixed * 1000)) > date.getTime()) {
              return (storageObject.get(PrintixAuthConstants.AUTH_ACCESS_TOKEN)) ? true : false;
            } else {
              return false;
            }
          } else {
            return false;
          }
        };
        //END AuthPrivate**************************************************************************************/


        //START $rootScope exposed methods*********************************************************************/
        $rootScope.handleEventServiceAccessTokenInvalid = function() {
          if (!AuthPrivate.isRefreshAccessTokenRunning &&
            !AuthPrivate.isGetAPITokensRunning &&
            !AuthPrivate.isSignOutRunning) {
            $window.location.reload();
          }
        }

        $rootScope.signOut = function(callback, url) {
          AuthPrivate.signOut(callback, url);
        };

        $rootScope.getAccessToken = function() {
          return AuthPrivate.getAccessToken();
        };

        $rootScope.checkIfAccessTokenIsValid = function() {
          return AuthPrivate.checkIfAccessTokenIsValid();
        };

        $rootScope.refreshAccessToken = function() {
          return AuthPrivate.refreshAccessToken();
        };

        $rootScope.checkCredentials = function() {
          return AuthPrivate.checkCredentials();
        };
        //END $rootScope exposed methods***********************************************************************/


        //START LISTENERS**********************************************/
        //If PrintixErrorConstants.UNAUTHORIZED string is emitted it will refresh the access token
        $rootScope.$on(PrintixErrorConstants.UNAUTHORIZED, function(name, requestObject) {
          AuthPrivate.refreshAccessToken().then(function() {
            $http(requestObject.config);
            $window.location.reload();
          }).catch(function(error) {});
        });

        $rootScope.$on(PrintixErrorConstants.FOUR_ZERO_THREE, function(name, requestObject) {
          // AuthPrivate.signOut(null, null, "ACCESS_DENIED");
        });

        //watch current user object for changes
        $rootScope.$watch(function() {
          return $rootScope.currentUser;
        }, function() {
          AuthPrivate.checkIfCurrentUserHasAccessToTheCurrentApp();
        });
        //END LISTENERS************************************************/
      }
    ])

    .service("PrintixAuthHeaderManager", ["$rootScope", "$q",
      function($rootScope, $q) {

        var setAuthHeader = function(config) {
          if (config) {
            config.headers["Authorization"] = "Bearer " + $rootScope.getAccessToken();
          } else {
            throw "PrintixAuthHeaderManager.setAuthHeader: config is missing";
          }
        };

        return {
          "request": function(config) {

            //create promise
            var deferred = $q.defer();

            //check if the request is not for .html or .js file and it IS an api call OR 'groupsTestPage.html' OR 'accept.html'
            if ((config.url.indexOf(".html") < 0 && config.url.indexOf(".js") < 0) && (config.url.indexOf("//api") !== -1) || (config.url.indexOf('groupsTestPage.html') !== -1 || config.url.indexOf('accept.html') !== -1)) {

              //if there are not headers in the config - make it and empty object
              if (!config.headers) {
                config.headers = {};
              }

              //check credentials, then they are ready
              $rootScope.checkCredentials().then(function() {
                //it is request to protected resource, but the access token is valid - resolve it
                setAuthHeader(config);
                deferred.resolve(config);
              }).catch(function(error) {
                deferred.reject();
              });
            } else {
              //any other request - resolve it
              deferred.resolve(config);
            }

            return deferred.promise;
          }
        };
      }
    ])

    .config(["$httpProvider", function($httpProvider) {
      $httpProvider.interceptors.push("PrintixAuthHeaderManager");
    }]);
})();